// Matches the persons-api CreateLivenessSessionRequest 'use_case' => 'max:64' rule,
// so a garbled or oversized query param does not flow unbounded into logs/cache.
const USE_CASE_MAX_LENGTH = 64;

/**
 * Trim and cap an optional use_case query param before sending it to persons-api.
 */
export function normalizeUseCase(rawUseCase: string | null): string | null {
    if (!rawUseCase) return null;
    const trimmed = rawUseCase.trim();
    return trimmed ? trimmed.slice(0, USE_CASE_MAX_LENGTH) : null;
}

// Canonical UUID string length (8-4-4-4-12 hex plus dashes). persons-api validates
// the format server-side ('trace_id' => 'nullable|uuid'); this only bounds length so
// a garbled/oversized query param can't flow unbounded into request bodies and logs.
const TRACE_ID_MAX_LENGTH = 36;

/**
 * Trim and cap an optional trace_id query param before sending it to persons-api.
 */
export function normalizeTraceId(rawTraceId: string | null): string | null {
    if (!rawTraceId) return null;
    const trimmed = rawTraceId.trim();
    return trimmed ? trimmed.slice(0, TRACE_ID_MAX_LENGTH) : null;
}
